import { Text } from "../../../../Text/text";
import { PlayRed, spaik, spaikIcon } from "../../../../../assets";
import { AuthContextType, useAuth } from "../../../../../auth/auth-provider";
import { IoMdPlayCircle } from "react-icons/io";

export const RightContentWhatsappModal: React.FC = () => {
  const { user } = useAuth() as AuthContextType;

  return (
    <div>
      <div className="flex align-items-center justify-content-center">
        {user.plataform.urlAvatar ? (
          <img
            src={user.plataform.urlAvatar}
            alt="imgBot"
            style={{ height: "120px" }}
          />
        ) : (
          <img src={spaikIcon} style={{ height: "120px" }} alt="imgBot" />
        )}
      </div>
      <div className="my-4">
        <Text
          fontSize="13px"
          fontWeight={500}
          lineHeight="16px"
          color="#FAFBFC"
        >
          Dica para integrar o seu número com a Meta Business Suite
        </Text>
      </div>
      <Text fontSize="11px" fontWeight={400} lineHeight="14px" color="#FAFBFC">
        Modelos de mensagens (templates) são importantes na API oficial do
        WhatsApp porque permitem enviar mensagens proativas e automáticas de
        forma padronizada e em conformidade com as regras da plataforma,
        garantindo mais previsibilidade e reduzindo riscos de bloqueios. Com
        templates aprovados, você agiliza a operação e melhora a experiência do
        cliente usando mensagens prontas com variáveis, botões e mídia para
        notificações, confirmações e campanhas.
      </Text>
      {/* <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "5px",
          marginTop: "10px"
        }}
      >
        <IoMdPlayCircle
          style={{ marginLeft: "0.14rem" }}
          size={25}
          color="white"
        />
        <div className="ml-2">
          <Text
            fontSize="13px"
            fontWeight={500}
            lineHeight="16px"
            color="#FAFBFC"
          >
            Vídeo - Chatbot
          </Text>
        </div>
      </div> */}
    </div>
  );
};
